module.exports = __webpack_public_path__ + "static/media/fimi.2fe29c2e.ttf";